import React from 'react'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import './../styles/reset.css'
import './../styles/common.css'


interface OwnProps {
  children?: React.ReactChild | React.ReactChild[]
  lang?: string
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  title?: string
}

type LayoutProps = OwnProps;

const Layout: React.FC<LayoutProps> = ({
  children,
}) => (
  <>
    <Header/>
    {children}
    <Footer />
  </>
)

export default Layout
